<template>
  <div>
    <Form class="part-number-generate-form" v-if="part && (part.reviewed !== 0 || part.part_identity)">
      <FormItem>
        <div v-if="hasPartNumber && !editing">
          <span class="part-number">{{ partNumber }}</span>
          <Button type="text" icon="md-create" @click="editing = true" style="margin-left: 20px;"></Button>
          <Poptip trigger="click" :title="$t('part_number_form.remove_confirm_message')" :ok-text="$t('remove')" @on-ok="handleRemovePNClicked" confirm transfer>
            <Button icon="md-close" ghost type="error" v-show="!saving" style="border:none;"></Button>
          </Poptip>
        </div>

        <div v-if="!hasPartNumber && !editing && part.category.class_number">
          <a class="help-text-clickable" @click="editing = true">
            {{ $t('part_number_form.click_enter_pn_help_text') }}</a> {{ $t('part_number_form.concat_text_or') }}
          <Button type="warning" @click="handleGeneratePNClicked" :loading="saving">
            {{ $t('part_number_form.generate_part_number_btn') }}  ({{ part.category.class_number }}) </Button>
        </div>

        <div class="create-or-update-part-number-element" v-if="editing">
          <Input v-model="partNumber" :placeholder="$t('part_number_form.enter_part_number')"></Input>
          <div class="text-align-right">{{ $t('part_number_form.enter_new_part_number_and_save') }}</div>
          <div class="text-align-right actions">
            <Button type="primary" @click="handleCreateOrChangePNClicked" :loading="saving">{{ $t('part_number_form.save_part_number_btn') }}</Button>
            <Button type="text" @click="editing = false">{{ $t('part_number_form.cancel_btn') }}</Button>
          </div>
        </div>
      </FormItem>
    </Form>
    <div v-else>{{ $t('part_number_form.part_moderation_status_is_not_reviewed') }}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "PartNumberForm",
  props: {
    part: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editing: false,
      saving: false,
      partIdentity: null,
      partNumber: ''
    }
  },
  computed: {
    hasPartNumber: function () {
      return this.partIdentity && this.partIdentity.part_number !== ''
    }
  },
  mounted () {
    if (this.part && this.part.part_identity) {
      this.setDataOnSaved(this.part.part_identity)
    }
  },
  methods: {
    ...mapActions([
      'removePartNumber',
      'createPartNumber',
      'generatePartNumber',
      'changePartNumber'
    ]),
    handleGeneratePNClicked () {
      this.saving = true
      this.generatePartNumber({ 'manufacturer_part_id': this.part.id })
        .then(resp => {
          this.setDataOnSaved(resp)
          this.$emit('on-part-number-saved', resp)
          this.$Message.info('Part number saved successfully.')
        })
        .finally(() => {
          this.saving = false
        })
    },
    handleRemovePNClicked () {
      this.saving = true
      this.removePartNumber(this.part.id).then(resp => {
        this.$Message.info('Part number removed.')
        this.$emit('on-part-number-deleted', this.partIdentity)
        this.partIdentity = null
        this.partNumber = ''
      }).finally(() => {
        this.saving = false
      })
    },
    handleCreateOrChangePNClicked () {
      this.saving = true
      const callbackFunc = this.hasPartNumber ? this.changePartNumber : this.createPartNumber

      callbackFunc({ 'manufacturer_part_id': this.part.id, 'part_number': this.partNumber })
        .then(resp => {
          this.setDataOnSaved(resp)
          this.editing = false
          this.$Message.info('Part number saved successfully.')

          this.$emit('on-part-number-saved', resp)
        })
        .finally(() => {
          this.saving = false
        })
    },
    setDataOnSaved (partIdentity) {
      this.partIdentity = partIdentity
      this.partNumber = partIdentity.part_number
    }
  },
  watch: {
    'part.part_identity': {
      deep: true,
      handler () {
        this.setDataOnSaved(this.part.part_identity)
      }
    }
  }
}
</script>
